import { Skeleton, Stack } from "@mui/material"

export default function SkeletonComponent() {
    return (
        <div style={{ width: '100%' }}>
            <Stack direction="row" spacing={2} sx={{ mb: 1 }}>
                <Skeleton variant="rectangular" width="25%" height={40} />
                <Skeleton variant="rectangular" width="30%" height={40} />
                <Skeleton variant="rectangular" width="25%" height={40} />
                <Skeleton variant="rectangular" width="20%" height={40} />
            </Stack>
            {Array.from(new Array(8)).map((_, i) => (
                <Stack key={i} direction="row" spacing={2} sx={{ mb: 1 }}>
                    <Skeleton variant="rectangular" width="25%" height={35} />
                    <Skeleton variant="rectangular" width="30%" height={35} />
                    <Skeleton variant="rectangular" width="25%" height={35} />
                    <Skeleton variant="rectangular" width="20%" height={35} />
                </Stack>
            ))}

        </div>
    )
}